// Recordings of the Salamander Grand Piano (Yamaha C5) by Alexander Holm, CC BY 3.0, every minor third from A0
// to C8 (see piano/LICENSE.md). Parcel emits them with a content hash in their names.
import a0 from 'url:./piano/A0.mp3';
import c1 from 'url:./piano/C1.mp3';
import ds1 from 'url:./piano/Ds1.mp3';
import fs1 from 'url:./piano/Fs1.mp3';
import a1 from 'url:./piano/A1.mp3';
import c2 from 'url:./piano/C2.mp3';
import ds2 from 'url:./piano/Ds2.mp3';
import fs2 from 'url:./piano/Fs2.mp3';
import a2 from 'url:./piano/A2.mp3';
import c3 from 'url:./piano/C3.mp3';
import ds3 from 'url:./piano/Ds3.mp3';
import fs3 from 'url:./piano/Fs3.mp3';
import a3 from 'url:./piano/A3.mp3';
import c4 from 'url:./piano/C4.mp3';
import ds4 from 'url:./piano/Ds4.mp3';
import fs4 from 'url:./piano/Fs4.mp3';
import a4 from 'url:./piano/A4.mp3';
import c5 from 'url:./piano/C5.mp3';
import ds5 from 'url:./piano/Ds5.mp3';
import fs5 from 'url:./piano/Fs5.mp3';
import a5 from 'url:./piano/A5.mp3';
import c6 from 'url:./piano/C6.mp3';
import ds6 from 'url:./piano/Ds6.mp3';
import fs6 from 'url:./piano/Fs6.mp3';
import a6 from 'url:./piano/A6.mp3';
import c7 from 'url:./piano/C7.mp3';
import ds7 from 'url:./piano/Ds7.mp3';
import fs7 from 'url:./piano/Fs7.mp3';
import a7 from 'url:./piano/A7.mp3';
import c8 from 'url:./piano/C8.mp3';

/** URL of the recording per MIDI note number. */
export const pianoSamples: Record<number, string> = {
  21: a0,
  24: c1,
  27: ds1,
  30: fs1,
  33: a1,
  36: c2,
  39: ds2,
  42: fs2,
  45: a2,
  48: c3,
  51: ds3,
  54: fs3,
  57: a3,
  60: c4,
  63: ds4,
  66: fs4,
  69: a4,
  72: c5,
  75: ds5,
  78: fs5,
  81: a5,
  84: c6,
  87: ds6,
  90: fs6,
  93: a6,
  96: c7,
  99: ds7,
  102: fs7,
  105: a7,
  108: c8
};
